interface Props {
  onClick: () => void;
  small?: boolean;
}

const SvgEditCartItem: React.FC<Props> = ({ onClick, small = false }) => {
  return (
    <svg
      onClick={onClick}
      style={{ transform: small ? "" : "scale(1.33,1.33)", cursor: "pointer" }}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15267_16077)">
        <path
          d="M13.6292 7.27392L14.3998 6.50333C15.2001 5.70306 15.2001 4.40064 14.3998 3.60005C14.0123 3.21286 13.4972 3 12.948 3C12.3989 3 11.8835 3.21317 11.4963 3.60036L10.726 4.37063L13.6292 7.27392ZM10.0562 5.04048L4.3499 10.7469C4.22832 10.8685 4.13579 11.0185 4.0821 11.1812L3.02415 14.3775C2.96762 14.5474 3.01215 14.7347 3.13879 14.8614C3.22942 14.9517 3.35006 15 3.47386 15C3.52375 15 3.57397 14.9921 3.62292 14.976L6.81825 13.9177C6.98152 13.864 7.13184 13.7715 7.25343 13.6496L12.9594 7.94344L10.0562 5.04048Z"
          className="fill-gray3"
        />
      </g>
      <defs>
        <clipPath id="clip0_15267_16077">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgEditCartItem;
